import React from 'react';
import cn from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

export type ShadowWrapperProps = {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export const ShadowWrapper: React.FC<ShadowWrapperProps> = ({ children, onClick }) => {
  const deviceType = useDeviceType();

  return (
    <div role="button" className={cn(styles['root'], styles[deviceType], styles['clickable'])} onClick={onClick}>
      {children}
    </div>
  );
};

ShadowWrapper.displayName = 'ShadowWrapper';
